var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5664 46.3164L33.1289 5.59375C31.3711 2.56641 26.7812 2.46875 25.0234 5.59375L1.58594 46.3164C-0.171875 49.3438 2.07422 53.25 5.6875 53.25H52.4648C56.0781 53.25 58.3242 49.4414 56.5664 46.3164ZM29.125 37.8203C31.5664 37.8203 33.6172 39.8711 33.6172 42.3125C33.6172 44.8516 31.5664 46.8047 29.125 46.8047C26.5859 46.8047 24.6328 44.8516 24.6328 42.3125C24.6328 39.8711 26.5859 37.8203 29.125 37.8203ZM24.8281 21.707C24.7305 21.0234 25.3164 20.4375 26 20.4375H32.1523C32.8359 20.4375 33.4219 21.0234 33.3242 21.707L32.6406 34.9883C32.543 35.6719 32.0547 36.0625 31.4688 36.0625H26.6836C26.0977 36.0625 25.6094 35.6719 25.5117 34.9883L24.8281 21.707Z",
    fill: "#EF4C4C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error-triangle.15cc2248.svg";
export { ForwardRef as ReactComponent };